import { useEffect } from "react";
import OrderScreen from "../features/order/OrderScreen";
import { useGlobalContext } from "../context/GlobalContext";

const OrderPage = () => {
  const { setSearch, setFilterEvent } = useGlobalContext();

  useEffect(() => {
    return () => {
      setSearch("");
      setFilterEvent("");
    };
  }, []);

  return (
    <>
      <OrderScreen />
    </>
  );
};

export default OrderPage;
